module.exports = __webpack_public_path__ + "img/home-4-line.44270061.svg";